export default __webpack_public_path__ + "images/6Y.1d7ec44.png";